import React from "react";
import { FormSection, FieldGrid, ToggleRow } from "../FormBits";

/*
GET /ticket/{id}/ has no connote-created/dispatched/delivered timestamps and
no tracking-link URL for either leg, and only one shared tracking_number - so
most of this tab is still placeholder. Backend confirmed (2026-09-25) none of
those timestamps/URLs exist on the model; the closest lead is that "connote"
data lives in the separate Transdirect booking endpoint
(BookingDetailTransdirectView), never pulled onto Ticket. tracking_number/
return_label are read as the RETURN leg (the ticket_status_list wording is
all about the return label being sent to and downloaded by the customer) -
backend can't confirm that from the model alone (it's leg-agnostic), so this
still needs a check against real sample data with ops before relying on it.
pickup_address is a free-text field entered at ticket creation, not an FK to
a ServiceCenter, so it won't always resolve to a real ASC address - it's
edited as the retailer address on the Product tab, so it's read-only here.

Editable: the outbound/inbound ticket references, tracking number, carrier
and date of return - all part of the page's Save draft (`draft`, see
useTicketDraft.js), as TicketProcess.js's Inbound/Outbound inputs.
*/
const DeliveryTab = function (props) {
  const { draft } = props;
  const ticket = props.ticket || {};
  const lockDraft = !props.canEdit || draft.saving;
  const draftField = function (key) {
    return Object.assign({ id: "ticketDelivery_" + key, disabled: lockDraft }, draft.bind(key));
  };

  const fulfilment = [
    { label: "ASC / Warehouse", placeholder: "e.g. Pegatron", value: ticket.service_center_name },
    { label: "Address", placeholder: "Fulfilment address", value: ticket.pickup_address },
  ];

  const outbound = [
    Object.assign(
      { label: "Outbound Ticket", placeholder: "Outbound reference" },
      draftField("outbound_ticket")
    ),
    { label: "Connote Created Date", placeholder: "", type: "date" },
    { label: "Connote Tracking ID", placeholder: "Tracking number" },
    { label: "Tracking Link", placeholder: "https://" },
    { label: "Dispatched Date", placeholder: "", type: "date" },
    { label: "Parcel Delivered Date", placeholder: "", type: "date" },
  ];

  const returning = [
    Object.assign(
      { label: "Inbound Ticket", placeholder: "Inbound reference" },
      draftField("inbound_ticket")
    ),
    Object.assign(
      { label: "Connote Tracking ID", placeholder: "Tracking number" },
      draftField("tracking_number")
    ),
    Object.assign(
      { label: "Carrier", placeholder: "Tracking service" },
      draftField("tracking_number_service")
    ),
    Object.assign({ label: "Date of Return", type: "date" }, draftField("date_of_return")),
    { label: "Return Connote Created Date", placeholder: "", type: "date" },
    { label: "Tracking Link", placeholder: "https://" },
    { label: "Return Label", placeholder: "https://", value: ticket.return_label },
    { label: "Dispatched Date", placeholder: "", type: "date" },
  ];

  return (
    <div className="tn-tabpanel">
      <FormSection title="Fulfilment">
        <FieldGrid fields={fulfilment} cols={2} />
      </FormSection>

      <FormSection title="Outbound Shipment">
        <FieldGrid fields={outbound} />
        <ToggleRow label="Confirmed delivery" />
      </FormSection>

      <FormSection title="Inbound Shipment">
        <FieldGrid fields={returning} />
      </FormSection>
    </div>
  );
};

export default DeliveryTab;
